import { api } from "./client";
import type {
  StudyParticipantStatus,
  SubmitStudyResponseRequest,
} from "@/lib/types/study";

export const studyApi = {
  getStatus: async (): Promise<StudyParticipantStatus | null> => {
    return await api.get("/study/me");
  },

  consent: async (): Promise<StudyParticipantStatus> => {
    return await api.post("/study/consent");
  },

  submitResponse: async (
    data: SubmitStudyResponseRequest,
  ): Promise<StudyParticipantStatus> => {
    return await api.post("/study/responses", data);
  },

  withdraw: async (): Promise<StudyParticipantStatus> => {
    return await api.post("/study/withdraw");
  },

  deleteMyData: async (): Promise<{ deleted: true }> => {
    return await api.delete("/study/data");
  },
};
